import { render, staticRenderFns } from "./Lifespan.vue?vue&type=template&id=7cc2a272"
import script from "./Lifespan.vue?vue&type=script&lang=js"
export * from "./Lifespan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports